import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Button from "./base/button";
import StaticImage from "./base/staticImage";
import SocialMedia from "./icons/socialMedia";

const Footer = () => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            footer {
              social {
                icon
                url
              }
              links {
                text
                url
              }
              disclaimer
              copy
              awards {
                logo
                url
              }
            }
          }
        }
      }
    `
  );

  const { social, links, disclaimer, copy, awards } = site.siteMetadata.footer;
  const socialItems = social.map((item, index) => (
    <li key={`footer-social-items-` + index}>
      <Button href={item.url} className={item.icon} wrapper={false} title={item.icon}>
        <SocialMedia name={item.icon} />
      </Button>
    </li>
  ));
  const linksItems = links.map((item, index) => (
    <li key={`footer-links-items-` + index}>
      <Button href={item.url} className={item.text} text={item.text} wrapper={false} />
    </li>
  ));

  const awardsItems = awards.map((item, index) => (
    <span className="award" key={`footer-awards-items-` + index}>
      <Button href={item.url} className={item.text} wrapper={false}>
        <StaticImage className="award-logos" src={item.logo} />
      </Button>
    </span>
  ));

  return (
    <footer className="footer">
      <div className="footer--wrapper">
        <div className="footer--wrapper__social">
          <span>Connect with us </span>
          <ul>{socialItems}</ul>
        </div>
      </div>
      <div className="footer--wrapper">
        <ul className="footer--wrapper__links">{linksItems}</ul>
      </div>
      <div className="footer--wrapper">
        <div className="footer--wrapper__copy">
          <div className="bodytext">
            <p>{disclaimer}</p>
            <span>{copy}</span>
          </div>
          <div className="awards">{awardsItems}</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
